import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledNotEcommerceContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-bottom: 12px;
`;

export const StyledNotEcommerceTitle = styled.h3`
  ${setFontVariant('subsectionTitle', colorsPalettes.carbon['500'])};
  font-weight: 400;
  margin: 0 0 4px;
`;

export const StyledNotEcommerceSubtitle = styled.p`
  ${setFontVariant('sectionTitle', colorsPalettes.carbon['300'])};
  margin: 0;
`;

export const StyledNotEcommerceUnreportedText = styled.p<{ disabled: boolean }>`
  font-weight: 600;
  margin: 0;
  ${({ disabled }) => (disabled ? `pointer-events: none;` : '')}
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const StyledNotEcommerceReportWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`;

export const StyledNotEcommerceIcon = styled(SWReactIcons)`
  height: 62px;
  width: 100px;
  margin: 14px 0px 18px;
`;
